<!--
  lovi
  登录 2020-1-8
-->
<template>
  <div class="w100">
    <van-nav-bar
      class="noShadow"
      :fixed="true"
      left-arrow
      @click-left="_back"
    />
    <div class="scroll-wrapper logReg-field">
      <h3>{{ $t("logReg.loginName") }}</h3>
      <ul>
        <template v-if="!codeLog">
          <li>
            <van-cell-group>
              <van-field
                clearable
                left-icon="icon-name"
                v-model="accountInfo.username"
                :error="accountError.username ? true : false"
                @input="changeUsername"
                :placeholder="$t('common.AccountPlaceholder')"
              />
            </van-cell-group>
          </li>
          <li>
            <van-cell-group>
              <van-field
                clearable
                left-icon="icon-lock"
                :right-icon="eye ? 'eye-o' : 'closed-eye'"
                @click-right-icon="eye = !eye"
                :type="eye ? 'text' : 'password'"
                v-model="accountInfo.password"
                :error="accountError.password ? true : false"
                @input="changePassword"
                :placeholder="$t('common.PasswordFormat')"
              />
            </van-cell-group>
          </li>
        </template>
        <template v-else>
          <li>
            <van-cell-group>
              <van-field
                class="van-field-phone"
                label="+63"
                clearable
                left-icon="icon-tel"
                v-model="mobileInfo.phone"
                type="tel"
                :error="mobileError.phone ? true : false"
                :maxlength="telMax"
                :formatter="_phoneFormat"
                @input="changePhone"
                :placeholder="$t('common.enterMobile')"
              />
            </van-cell-group>
          </li>
          <li>
            <van-cell-group>
              <van-field
                class="van-field-code"
                clearable
                left-icon="icon-lock"
                v-model="mobileInfo.code"
                :error="mobileError.code ? true : false"
                @input="changeCode"
                :placeholder="$t('common.enterVerificationCode')"
              >
                <div slot="button">
                  <van-count-down
                    class="text-orange"
                    v-if="countDownFlag"
                    :time="60000"
                    :format="$t('common.remaining') + ' sss'"
                    @finish="finished"
                  />
                  <span v-else class="text-orange" @click="sendMobile">
                    {{
                      againFlag ? $t("common.getAgain") : $t("common.getItNow")
                    }}
                  </span>
                </div>
              </van-field>
            </van-cell-group>
          </li>
        </template>
        <li class="text-list">
          <span @click="logWay" class="text-blue">
            {{ codeLog ? $t("logReg.accountLogin") : $t("logReg.mobileLogin") }}
          </span>
          <div class="right">
            <van-checkbox v-model="checkedPsd" checked-color="#FE7800">
              {{ $t("logReg.rememberPassword") }}
            </van-checkbox>
            <span class="text-orange" @click="forgetPsd">
              {{ $t("common.forgetPassword") }}?
            </span>
          </div>
        </li>

        <li>
          <van-button
            round
            type="primary"
            block
            :loading="btnLoading"
            @click="submit"
          >
            {{ $t("common.login") }}
          </van-button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import * as validate from "@/commonJs/validate.js";
export default {
  name: "log",
  meta: {
    power: false,
    service: false
  },
  components: {},
  data() {
    return {
      codeLog: false, //验证码登录
      btnLoading: false, //按钮loadding
      eye: false, //明文密文
      accountInfo: {
        username: "",
        password: ""
      },
      accountError: {
        username: false,
        password: false
      },

      mobileInfo: {
        phone: "",
        code: ""
      },
      mobileError: {
        phone: false,
        code: false
      },

      telMax: 13,

      countDownFlag: false, // 倒计时
      againFlag: false, // 重新获取短信验证码

      checkedPsd: false // 记住密码
    };
  },
  created() {
    if (localStorage.getItem("username")) {
      this.accountInfo.username = localStorage.getItem("username");
      this.accountInfo.password = localStorage.getItem("password");
      this.checkedPsd = true;
    } else {
      this.accountInfo.username = "";
      this.accountInfo.password = "";
      this.checkedPsd = false;
    }
  },
  mounted() {},
  computed: {},
  methods: {
    logWay() {
      // 切换账号、手机登录
      this.codeLog = !this.codeLog;
      this.countDownFlag = false;
      this.againFlag = false;
    },
    forgetPsd() {
      // 忘记密码
      this.$router.push({
        path: "/mobile",
        name: "mobile",
        query: { flag: "forgetPsd" }
      });
    },
    changeUsername() {
      // 账号
      // this.accountError.username = validate.validateUserName(this.accountInfo.username)
    },
    changePassword() {
      // 验证密码
      this.accountError.password = validate.validatePsd(
        this.accountInfo.password
      );
    },
    changePhone(value) {
      // 手机
      console.log("phone", value);
      let firstStr = (value + "").substr(0, 1);
      if (firstStr == "0") {
        //如果第一个字符是0，则输入框最多输入13位
        this.telMax = 13;
      } else {
        //否则输入框最多输入12位
        this.telMax = 12;
      }
      let phone = value.replace(/\s/g, "");
      this.mobileError.phone = validate.validateMobile(phone);
    },
    changeCode() {
      // 验证码
      this.mobileError.code = validate.validateCode(this.mobileInfo.code);
    },
    finished() {
      // 倒计时结束
      this.countDownFlag = false;
      this.againFlag = true;
    },
    sendMobile() {
      // 获取手机验证码
      let vm = this;
      if (vm.mobileInfo.phone == "") {
        vm.$toast(vm.$t("common.mobileNull"));
        return false;
      }
      if (vm.mobileError.phone) {
        vm.$toast(vm.mobileError.phone);
        return false;
      }
      let params = {};
      // 号码处理先删除空格转换成数字再补0
      params.phone = "0" + Number(vm.mobileInfo.phone.replace(/\s/g, ""));
      params.type = 1;
      vm.$post("/app/captcha/sendMobile", params, {
        alert: true,
        loading: true
      }).then(res => {
        console.log("sendMobile", res);
        if (res.code == 0) {
          vm.countDownFlag = true;
        } else {
          vm.$toast(res.msg);
        }
      });
    },
    submit() {
      if (this.codeLog) {
        // 验证码登录
        this.loginByMobile();
      } else {
        this.login();
      }
    },
    login() {
      // 账号登录
      let vm = this;
      if (vm.accountInfo.username == "") {
        vm.$toast(vm.$t("common.AccountPlaceholder"));
        return false;
      }
      for (let key in vm.accountError) {
        if (vm.accountError[key]) {
          vm.$toast(vm.accountError[key]);
          return false;
        }
      }
      let newAccountInfo = JSON.parse(JSON.stringify(vm.accountInfo));
      let str = newAccountInfo.username;
      var username = Number(str);
      if (!isNaN(username)) {
        newAccountInfo.username = "0" + username;
      }
      newAccountInfo.enter = vm.enter;
      vm.btnLoading = true;
      vm.$post("/app/user/login", newAccountInfo, { alert: true }).then(res => {
        vm.btnLoading = false;
        console.log("login", res);
        if (res.code == 0) {
          if (vm.checkedPsd) {
            localStorage.setItem("username", newAccountInfo.username);
            localStorage.setItem("password", newAccountInfo.password);
          } else {
            localStorage.setItem("username", "");
            localStorage.setItem("password", "");
          }

          localStorage.setItem("token", res.data.token);
          vm.$store.dispatch("SET_TOKEN", res.data.token);
          vm.$store.dispatch("GET_USER_INFO");
          vm.$toast(res.msg);
          vm.$router.push({
            path: "/home"
          });
        } else {
          vm.$toast(res.msg);
        }
      });
    },
    loginByMobile() {
      // 手机登录
      let vm = this;
      for (let key in vm.error) {
        if (vm.mobileError[key]) {
          vm.$toast(vm.mobileError[key]);
          return false;
        }
      }
      if (vm.mobileInfo.phone == "") {
        vm.$toast(vm.$t("verify.mobileNull"));
        return false;
      }
      if (vm.mobileInfo.code == "") {
        vm.$toast(vm.$t("verify.verificationCodeNull"));
        return false;
      }
      let newMobileInfo = JSON.parse(JSON.stringify(vm.mobileInfo));
      let newMobile = "0" + Number(vm.mobileInfo.phone.replace(/\s/g, ""));
      newMobileInfo.phone = newMobile;
      newMobileInfo.enter = vm.enter;
      vm.btnLoading = true;
      vm.$post("/app/user/loginByMobile", newMobileInfo, { alert: true }).then(
        res => {
          vm.btnLoading = false;
          console.log("loginByMobile", res);
          if (res.code == 0) {
            vm.$toast(res.msg);
            localStorage.setItem("token", res.data.token);
            vm.$store.dispatch("SET_TOKEN", res.data.token);
            vm.$store.dispatch("GET_USER_INFO");
            vm.$router.push({
              path: "/home"
            });
          } else {
            vm.$toast(res.msg);
          }
        }
      );
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
.text-list {
  display: flex;
  justify-content: space-between;
  align-items: center;
  line-height: 1;
  .right {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    /deep/.van-checkbox {
      margin-right: 10px;
      .van-checkbox__icon {
        width: 16px;
        height: 16px;
        line-height: 16px;
        font-size: 16px;
      }
      .van-checkbox__label {
        margin-left: 5px;
        color: #fe7800;
        line-height: 1;
      }
    }
  }
}
</style>
